module.exports = __webpack_public_path__ + "img/animal_festa_logo.35a09eb1.png";